<dx-chart
  id="fuel-hourly-consumption-chart"
  palette="Carmine"
  [dataSource]="dataSource">
  <dxo-title horizontalAlignment="center" text="Consommation L/h">
    <dxo-font color="black" [weight]="300"></dxo-font>
  </dxo-title>

  <dxo-zoom-and-pan
    [dragToZoom]="true"
    valueAxis="none"
    argumentAxis="both"
  ></dxo-zoom-and-pan>

  <dxi-series argumentField="tracker_time" valueField="fuel_hourly_consumption_rate"></dxi-series>

  <dxo-argument-axis argumentType="datetime"></dxo-argument-axis>
  <dxo-value-axis>
    <dxo-label [customizeText]="valueAxisAddUnit"></dxo-label>
  </dxo-value-axis>

  -
  <dxo-size [height]="height" [width]="width-32"></dxo-size>

  <dxo-common-series-settings width="2">
    <dxo-point [visible]="false"></dxo-point>
    <dxo-hover-style width="2"></dxo-hover-style>
  </dxo-common-series-settings>

  <dxo-legend [visible]="false"></dxo-legend>

  <dxo-common-axis-settings>
    <dxo-grid [visible]="true"></dxo-grid>
  </dxo-common-axis-settings>

  <dxo-export [enabled]="true"></dxo-export>

  <dxo-tooltip contentTemplate="chartTooltip" [zIndex]="300000" argumentFormat="shortDateShortTime"
               [enabled]="true"></dxo-tooltip>
  <div *dxTemplate="let info of 'chartTooltip'">
    <div>{{info.value | number}} L/h - {{info.argumentText}}</div>
  </div>
</dx-chart>
